import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import Header from "../components/Header";
import "./LoginPage.css";

export default function LoginPage() {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "kz");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [ssoError, setSsoError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const val = params.get("sso_error");
    if (val) {
      setSsoError(val.replace(/\+/g, " "));
      params.delete("sso_error");
      const newUrl =
        window.location.pathname +
        (params.toString() ? `?${params.toString()}` : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  useEffect(() => {
    axios.defaults.headers.common["Accept-Language"] = locale;
    document.documentElement.lang = locale;
    localStorage.setItem("locale", locale);
  }, [locale]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "locale" && e.newValue) setLocale(e.newValue);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    document.body.classList.add("no-scroll-login");
    return () => document.body.classList.remove("no-scroll-login");
  }, []);

useEffect(() => {
  const token = localStorage.getItem("token");

  console.log("TOKEN:", token);

  if (token) {
    console.log("Переходим на /staff-groups");
    window.location.replace("/staff-groups");
  } else {
    console.log("Токена нет");
  }
}, []);

  const dict = {
    kz: {
      title: "Қызметкерлерге кіру",
      username: "Пайдаланушы аты",
      password: "Құпиясөз",
      login: "Кіру",
      sso: "Egov арқылы кіру",
      back: "⬅ Басты бетке оралу",
      error: "Пайдаланушы аты немесе құпиясөз қате.",
      show: "Құпиясөзді көрсету",
      hide: "Құпиясөзді жасыру",
      empty: "Логин мен құпиясөзді толтырыңыз.",
      ssoErrorTitle: "Аккаунт табылмады",
      ssoErrorText:
        "Сіздің аккаунтыңыз жүйеде табылмады немесе белсенді емес. Техникалық қолдау қызметіне хабарласыңыз",
    },
    ru: {
      title: "Вход для сотрудников",
      username: "Имя пользователя",
      password: "Пароль",
      login: "Войти",
      sso: "Вход через Egov",
      back: "⬅ Вернуться на главную",
      error: "Неверное имя пользователя или пароль.",
      show: "Показать пароль",
      hide: "Скрыть пароль",
      empty: "Заполните логин и пароль.",
      ssoErrorTitle: "Аккаунт не найден",
      ssoErrorText:
        "Ваш аккаунт не найден в системе или не активен. Обратитесь в службу технической поддержки:",
    },
  };

  const t = dict[locale];

  const handleSsoLogin = () => {
    window.location.href =
      "https://expertise.gov.kz/api/auth/idp/redirect/staff";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;

    const u = username.trim();
    const p = password.trim();

    if (!u || !p) {
      setError(t.empty);
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await axios.post("https://expertise.gov.kz/api/login", {
        username,
        password,
      });

      

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user_id", res.data.user.id);
      localStorage.setItem("username", res.data.user.name);
      localStorage.setItem("role", res.data.user.role || "");
      localStorage.setItem("department", res.data.user.department || "");

      window.location.href = "/staff-groups";
    } catch (err) {
      setError(err.response?.data?.message || t.error);
    } finally {
      setLoading(false);
    }
  };

  const goToHome = () => (window.location.href = "/");

  return (
    <div className="login-page">
      <div className="login-ornament glow sparkles" aria-hidden="true">
        <div
          className="orn-img a"
          style={{ backgroundImage: "url(/img/ornament.svg)" }}
        />
        <div
          className="orn-img b"
          style={{ backgroundImage: "url(/img/ornament.svg)" }}
        />
        <div
          className="orn-img c"
          style={{ backgroundImage: "url(/img/ornament.svg)" }}
        />
      </div>

      <div className="container header-wrap">
        <Header locale={locale} setLocale={setLocale} />
      </div>

      <main className="container login-wrap">
        <section className="login-card glass">
          <h1 className="login-title">{t.title}</h1>

          {ssoError && (
  <div className="sso-error-alert">
    <div className="sso-error-left">
      <svg
        className="sso-error-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    </div>
    <div className="sso-error-body">
      <strong className="sso-error-title">{t.ssoErrorTitle}</strong>
      <span className="sso-error-text">{t.ssoErrorText}</span>
    </div>
    <button
      type="button"
      className="sso-error-close"
      onClick={() => setSsoError("")}
      aria-label="Закрыть"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>
)}

          {error && <p className="error">{error}</p>}

          <form
            onSubmit={handleLogin}
            autoComplete="on"
            className="form form--auth"
          >
            <div className="form-group">
              <label htmlFor="login-username">{t.username}</label>
              <input
                id="login-username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="login-password">{t.password}</label>
              <div className="password-wrapper">
                <input
                  id="login-password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? t.hide : t.show}
                  title={showPassword ? t.hide : t.show}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`login-btn ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <div className="dots-loader">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              ) : (
                t.login
              )}
            </button>
          </form>

          <button
            type="button"
            className="login-btn egov-btn"
            onClick={handleSsoLogin}
          >
            {t.sso}
          </button>

          <button onClick={goToHome} className="back-home-btn">
            {t.back}
          </button>
        </section>
      </main>
    </div>
  );
}